import {h, Fragment} from "preact"
import { useFacets, useSort } from "@nosto/preact"
import { useEffect } from "preact/hooks"
import { sortOptions } from "../config"
import Facet from "./Facet"
import Select from "./elements/Select"
import RangeFacet from "./RangeFacet"
import Icon from "./elements/Icon"

export const toggleButtonId = "toggle-mobile-sidebar"

function ToggleSidebarButton({ className }) {
    return (
        <label
            className={`ns-act-btn ns-close-sidebar ns-d-block ns-d-md-none ns-text-align-right ns-align-items-center ns-clickable ns-font-3 ${className}`}
            for={toggleButtonId}
        >
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M1.53092 17.1334L0.864258 16.4667L8.33092 9.00003L0.864258 1.53337L1.53092 0.866699L8.99759 8.33337L16.4643 0.866699L17.1309 1.53337L9.66426 9.00003L17.1309 16.4667L16.4643 17.1334L8.99759 9.6667L1.53092 17.1334Z" fill="#E1E0DF"/>
            </svg>
        </label>
    )
}

export default function SideBar() {
    const { loading, facets } = useFacets()
    const { activeSort, setSort } = useSort(sortOptions)

    useEffect(() => {
        const toggleCheckbox = document.getElementById(toggleButtonId)
        const body = document.body

        const handleToggleChange = () => {
            if (toggleCheckbox.checked) {
                body.classList.add("overflow-hidden")
            } else {
                body.classList.remove("overflow-hidden")
            }
        }

        toggleCheckbox.addEventListener("change", handleToggleChange)

        return () => {
            toggleCheckbox.removeEventListener("change", handleToggleChange)
            body.classList.remove("overflow-hidden")
        }
    }, [])

    const handleSortChange = event => {
        setSort(event.target.value)
    }
    
    const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }))

    return facets?.length > 0 ? (
        <>
            <input type="checkbox" id={toggleButtonId} class="ns-facet-sidebar-toggle ns-d-none" />
            <label
                class="ns-sidebar-backdrop ns-fixed ns-w-100 ns-h-100 ns-background-black ns-d-none"
                for={toggleButtonId}
            />
            <div
                class="ns-sidebar-wrapper ns-h-100"
            >
                <div class="ns-sidebar-content ns-relative ns-h-100 ns-mr-0 ns-mr-md-auto">
                    <div class="ns-sidebar-header">
                        <span class="ns-font-medium ns-font-5 ns-color-white">Filters</span>
                        <ToggleSidebarButton />
                    </div>
                    <div class="ns-sidebar-menu">
                        <div className="ns-sidebar-dropdown">
                            <div className="ns-anchor">Sort by</div>
                        </div>
                        <div className="ns-sidebar-submenu ">
                        <Select
                            value={activeSort}
                            onChange={e => handleSortChange(e)}
                            className="ns-selection-dropdown-sort-menu"
                            options={options}
                            label={"Sort by"}
                        />
                        </div>
      
                        <ul class="ns-list-unstyled ns-p-0 ns-m-0">
                            {facets?.map(facet => {
                                switch (facet.type) {
                                    case "terms":
                                        return <Facet key={facet.id} facet={facet} />
                                    case "stats":
                                        return <RangeFacet key={facet.id} facet={facet} />
                                    default:
                                        return null
                                }
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        </>
    ) : (
        ""
    )
}
